import { BaseService } from '@core/base/service/base-service'
import * as Sentry from '@sentry/react'
import { captureException } from '@sentry/react'

export const SentryService = new (class SentryService extends BaseService {
    constructor() {
        super('sentry.service')
    }

    get isEnabled() {
        return (
            !import.meta.env.DEV &&
            this.envVars.REACT_APP_SENTRY_DSN &&
            this.envVars.REACT_APP_ENV
        )
    }

    init() {
        if (this.isEnabled) {
            const {
                REACT_APP_SENTRY_DSN,
                REACT_APP_ENV,
                REACT_APP_SENTRY_SLUG,
            } = this.envVars

            try {
                Sentry.init({
                    dsn: REACT_APP_SENTRY_DSN,
                    integrations: [Sentry.replayIntegration()],
                    tracesSampleRate: 1.0,
                    autoSessionTracking: false,
                    sendClientReports: false,
                    environment: REACT_APP_ENV,
                    replaysSessionSampleRate: 0.1,
                    replaysOnErrorSampleRate: 1.0,
                    maxBreadcrumbs: 20,
                })
            } catch (e) {
                console.log('Sentry init error', e)
            }
        }
    }

    error(error: Error) {
        this.isEnabled && captureException(error)
    }
})()
